/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Alarms_Journal_Mobilerow1Inputs */



/**
* | output |
* | --- |
* | "Start: {start} • End: {end}" |
*
* @param {Alarms_Journal_Mobilerow1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_journal_mobilerow1 = /** @type {((inputs: Alarms_Journal_Mobilerow1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Journal_Mobilerow1Inputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Start: ${i?.start}  •  End: ${i?.end}`)
	return /** @type {LocalizedString} */ (`Début: ${i?.start}  •  Fin: ${i?.end}`)
});
export { alarms_journal_mobilerow1 as "alarms_journal_mobileRow" }